import React from 'react';

type Props = {
  name: string;
};

/**
 * Renders a single attribute of an attendee on the attendee profile page
 * @param name The name of the attribute
 * @param children The value of the attribute
 */
export default function Attribute({name, children}: React.PropsWithChildren<Props>) {
  return (
    <div className="grid grid-cols-3 gap-4 py-1.5">
      <dt className="text-gray-dark">{name}</dt>
      <dd className="col-span-2">{children}</dd>
    </div>
  );
}
